import { render, staticRenderFns } from "./ServicoAtendimentoEditarModal.vue?vue&type=template&id=028bd6d3&scoped=true"
import script from "./ServicoAtendimentoEditarModal.vue?vue&type=script&lang=js"
export * from "./ServicoAtendimentoEditarModal.vue?vue&type=script&lang=js"
import style0 from "./ServicoAtendimentoEditarModal.vue?vue&type=style&index=0&id=028bd6d3&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028bd6d3",
  null
  
)

export default component.exports